import { render } from "./QuotaSummary.vue?vue&type=template&id=323146f5&scoped=true"
import script from "./QuotaSummary.vue?vue&type=script&lang=js"
export * from "./QuotaSummary.vue?vue&type=script&lang=js"

import "./QuotaSummary.vue?vue&type=style&index=0&id=323146f5&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323146f5"]])

export default __exports__